import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./SelectDividerDropdown.module.css";
import Button from "../Button";
import SelectColorInput from "../SelectColorInput";
import DividerSectionElement from "../DividerSectionElement";
import { SwitchTransition, CSSTransition } from "react-transition-group";

/**
 * Interactive component.
 * A section editor that allows the user to customize a feed item's divider section.
 */
export function SelectDividerDropdown({
  dividerColor,
  setDividerColor,
  isOpen,
  setIsOpen,
  index
}) {
  const [customColor, setCustomColor] = useState("#fff");
  const [isSelectColor, setIsSelectColor] = useState(false);

  const colorRef = useRef();
  const transitionRef = useRef(null); // Instantiate ref for transitions

  useOutsideAlerter(colorRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsSelectColor(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <div className={styles.container}>
      <SwitchTransition mode="out-in">
      <CSSTransition
        key={isOpen ? "dropdown" : "button"}
        nodeRef={transitionRef} // StrictMode integrity
        classNames={{
          enter: styles["fade-enter"],
          exit: styles["fade-exit"],
          enterActive: styles["fade-enter-active"],
          exitActive: styles["fade-exit-active"],
        }}
        timeout={300}
      >
        <div ref={transitionRef}> {/* Wrap everything in a refable node */}
          {!isOpen ? (
            <button
              className={styles["divider-button"]}
              onClick={() => setIsOpen(index)}
            >
              <DividerSectionElement
                dividerColor={dividerColor.substr(
                  dividerColor.indexOf(" ") + 1
                )}
              />
            </button>
          ) : (
            <div className={styles.dropdown}>
              <div className={styles["dropdown-header"]}>
                <div ref={colorRef}>
                  <SelectColorInput
                    currentColor={dividerColor}
                    setCurrentColor={(e) => {
                      setDividerColor(
                        `${e.target.title} ${e.target.style.backgroundColor}`, index
                      );
                      setIsSelectColor(false);
                    }}
                    customColor={customColor}
                    setCustomColor={(value) => setCustomColor(value)}
                    isOpen={isSelectColor}
                    setIsOpen={() =>
                      setIsSelectColor((isSelectColor) => !isSelectColor)
                    }
                  />
                </div>
                <Button
                  text="Done"
                  onClick={() => setIsOpen(index)}
                  className={styles.button}
                />
              </div>
              <div className={styles["new-divider-container"]}>
                <DividerSectionElement
                  dividerColor={dividerColor.substr(
                    dividerColor.indexOf(" ") + 1
                  )}
                />
              </div>
            </div>
          )}
        </div>
      </CSSTransition>
    </SwitchTransition>
    </div>
    
  );
}

SelectDividerDropdown.propTypes = {
  /**
   * The current color of the divider.
   */
  dividerColor: PropTypes.string,
  /**
   * Function that changes the divider color.
   */
  setDividerColor: PropTypes.func,
  /**
   * Boolean that determines if the dropdown is open.
   */
  isOpen: PropTypes.bool,
  /**
   * Function that controls the dropdown.
   */
  setIsOpen: PropTypes.func,
};
